import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDownloadURL, getStorage, ref } from "firebase/storage";

import { firebaseConfig } from "./firebase_config.js";

let modularApp;

if (!getApps().length) {
    modularApp = initializeApp(firebaseConfig);
} else {
    modularApp = getApp();
}

export const db = getFirestore(modularApp);
export const rtdb = getDatabase(modularApp);

export function getFirebaseApp() {
    return modularApp;
}

export function getFirebaseRtdb() {
    return rtdb;
}

export function getFirebaseFunction(name, region = undefined) {
    const functions = getFunctions(modularApp, region);
    return httpsCallable(functions, name);
}

export function getFirebaseStorage() {
    return getStorage(modularApp);
}

export function getFirebaseStorageRef(path) {
    return ref(getStorage(modularApp), path);
}

export function getFirebaseStorageDownloadUrl(path) {
    return getDownloadURL(ref(getStorage(modularApp), path));
}

export function getFirebaseStoragePublicUrl(path) {
    return `https://firebasestorage.googleapis.com/v0/b/${firebaseConfig.storageBucket}/o/${encodeURIComponent(path)}?alt=media`;
}

export function getFirebaseAuth() {
    return getAuth(modularApp);
}

// export function getFirebaseFunctions() {
//     return getFunctions(modularApp);
// }
